import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";

// Liste des formats supportés par Quill
const formats = [
  "header", "font", "size",
  "bold", "italic", "underline", "strike", "blockquote",
  "list", "bullet", "indent",
  "link", "image", "video", "code-block", "color", "background", "align",
];

// Configuration des modules
const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    [{ font: [] }],
    [{ size: ["small", false, "large", "huge"] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ align: [] }],
    ["link", "image", "video"],
    ["code-block", "clean"],
  ],
};

const QuillWrapper = ({ forwardedRef, ...props }) => {
  const [ReactQuill, setReactQuill] = useState(null);
  const containerRef = useRef(null);
  const [isQuillLoaded, setIsQuillLoaded] = useState(false);

  // Polyfill pour findDOMNode
  if (typeof ReactDOM.findDOMNode !== "function") {
    ReactDOM.findDOMNode = function (component) {
      if (component && component.current) {
        return component.current;
      }
      return component;
    };
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      import("react-quill").then((mod) => {
        setReactQuill(() => mod.default);
        setIsQuillLoaded(true);
      });
    }
  }, []);

  if (!isQuillLoaded) {
    return (
      <div className="flex items-center justify-center rounded border p-4">
        <div className="mr-2 h-5 w-5 animate-spin rounded-full border-b-2 border-t-2 border-[#57A863]"></div>
        <span className="text-sm text-gray-500">
          Chargement de l'éditeur...
        </span>
      </div>
    );
  }

  return (
    <ReactQuill
      ref={forwardedRef || containerRef}
      modules={modules}
      formats={formats}
      {...props}
    />
  );
};

export default React.forwardRef((props, ref) => {
  return <QuillWrapper {...props} forwardedRef={ref} />;
});
